/**
 * @generated SignedSource<<81cda190541e75a1f6ea645863ff4c52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GenerateAiImageStyle = "auto" | "design" | "general" | "realistic" | "render_3d" | "%future added value";
export type GenerateAiImageInput = {
  createAsset?: boolean | null;
  organizationId: string;
  productId?: string | null;
  prompt: string;
  style: GenerateAiImageStyle;
};
export type GenerateContentWithAIProvider_GenerateAiImageCommitMutation$variables = {
  input: GenerateAiImageInput;
};
export type GenerateContentWithAIProvider_GenerateAiImageCommitMutation$data = {
  readonly response: {
    readonly botResponseId: string | null;
    readonly data: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly url: string;
    } | null;
  };
};
export type GenerateContentWithAIProvider_GenerateAiImageCommitMutation = {
  response: GenerateContentWithAIProvider_GenerateAiImageCommitMutation$data;
  variables: GenerateContentWithAIProvider_GenerateAiImageCommitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateAiImageResponse",
    "kind": "LinkedField",
    "name": "generateAiImageInMediaPicker",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "botResponseId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateContentWithAIProvider_GenerateAiImageCommitMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateContentWithAIProvider_GenerateAiImageCommitMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89b72b462f7da6d3b802b61ee429d832",
    "id": null,
    "metadata": {},
    "name": "GenerateContentWithAIProvider_GenerateAiImageCommitMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateContentWithAIProvider_GenerateAiImageCommitMutation(\n  $input: GenerateAiImageInput!\n) {\n  response: generateAiImageInMediaPicker(input: $input) {\n    data\n    node {\n      id\n      url\n    }\n    botResponseId\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af7a93b0d2ab69b3ae81c143ec07c956";

export default node;
